/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddonsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AddonsQuery = {
  readonly __typename?: 'Query';
  readonly addons: {
    readonly __typename?: 'Addons';
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly cost: number;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    }>;
  };
};

export const addonsQueryMock: ExecutionResult<AddonsQuery> = {
  data: {
    addons: {
      products: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          name: 'Hello World',
          cost: 65,
          asset: { url: 'Hello World' },
        },
        {
          id: 'a7a7163b-a7ed-4a96-a8a1-85e3da00a9a4',
          name: 'Hello World',
          cost: -2,
          asset: { url: 'Hello World' },
        },
        {
          id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          name: 'Hello World',
          cost: -18,
          asset: { url: 'Hello World' },
        },
      ],
    },
  },
};

export const AddonsDocument = gql`
  query addons {
    addons {
      products {
        id
        name
        cost
        asset {
          url
        }
      }
    }
  }
`;

export function useAddonsQuery(
  options?: Omit<Urql.UseQueryArgs<AddonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AddonsQuery, AddonsQueryVariables>({
    query: AddonsDocument,
    ...options,
  });
}
